import './bootstrap';

import HomeComponent from '../pages/home/home.vue';
import HotelComponent from '../pages/hotel/hotel.vue';
import LocalizacaoComponent from '../pages/hotel/localizacao.vue';
import SuiteNupiciasComponent from '../pages/acomodacoes/suite-nupcias.vue';
import QuartoCasalComponent from '../pages/acomodacoes/quarto-casal.vue';
import QuartoDuploComponent from '../pages/acomodacoes/quarto-duplo.vue';
import QuartoIndividualComponent from '../pages/acomodacoes/quarto-individual.vue';
import ServicosComponent from '../pages/servicos/servicos.vue';
import CafeComponent from '../pages/cafe/cafe.vue';
import ReservasComponent from '../pages/reservas/reservas.vue';
import ResplendorComponent from '../pages/resplendor/resplendor.vue';

import App from '../app.vue';
import Vue from 'vue'
import VueRouter from 'vue-router'
import VueResource from 'vue-resource'

Vue.use(VueResource)
Vue.http.options.root = 'http://www.resplendorcenterhotel.com.br/email-api/api';
var MailResource = Vue.resource('sendMail');
export {MailResource}

Vue.use(VueRouter)

const router = new VueRouter({
    routes:[
        {
            path: '/',
            component: HomeComponent
        },
        {
            path: '/home',
            name: 'home',
            component: HomeComponent
        },
        {
            path: '/hotel',
            name: 'hotel',
            component: HotelComponent
        },
        {
            path: '/hotel/localizacao',
            name: 'localizacao',
            component: LocalizacaoComponent
        },
        {
            path: '/acomodacoes/suite-nupcias',
            name: 'suite-nupcias',
            component: SuiteNupiciasComponent
        },
        {
            path: '/acomodacoes/quarto-casal',
            name: 'quarto-casal',
            component: QuartoCasalComponent
        },
        {
            path: '/acomodacoes/quarto-duplo',
            name: 'quarto-duplo',
            component: QuartoDuploComponent
        },
        {
            path: '/acomodacoes/quarto-individual',
            name: 'quarto-individual',
            component: QuartoIndividualComponent
        },
        {
            path: '/servicos',
            name: 'servicos',
            component: ServicosComponent
        },
        {
            path: '/cafe',
            name: 'cafe',
            component: CafeComponent
        },
        {
            path: '/reservas',
            name: 'reservas',
            component: ReservasComponent
        },
        {
            path: '/resplendor',
            name: 'resplendor',
            component: ResplendorComponent
        },
        {
            path: '*',
            redirect: '/home'
        }
    ]
});

const app = new Vue({
        el:'#app',
        router: router,
        render: h => h(App)
})



//////////////////
// WEBPACK FOOTER
// ./src/js/main.js
// module id = 19
// module chunks = 0